/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.4.0 (NJsonSchema v10.1.26.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export interface UserDto {
  companyName: string | undefined;
  emailAddress: string | undefined;
  displayName: string | undefined;
  accountType: CustomerTypeEnum;
  customerAccountId: string;
}

export interface SessionConfiguration {
  user: UserDto | undefined;
  language: string | undefined;
  navItems: NavItemDto[] | undefined;
  messages: MessageModel[] | undefined;
  featureFlags: FeatureFlags | undefined;
}

export interface NavItemDto {
  name: string | undefined;
  url: string | undefined;
}

export interface MessageModel {
  title: string | undefined;
  bodyHtml: string | undefined;
  messageType: string | undefined;
}

export interface FeatureFlags {
  featureAddToMyCourseEnabled: boolean;
  featureMessagesEnabled: boolean;
  featureMessageFeedbackEnabled: boolean;
  uxSignalsEnabled: boolean;
  useUxSignalsDemo: boolean;
  featureMessageReplyEnabled: boolean;
  redirectToFastForwardCompanyEnabled: boolean;
  consentToReferralpartiesEnabled: boolean, 
  giveConsentButtonEnabled: boolean,
}

export interface BaseDocumentModel {
  key: string | undefined;
  id: string | undefined;
  sanityType: string | undefined;
  sanityRevision: string | undefined;
  sanityKey: string | undefined;
  sanityCreatedAt: string | undefined;
  sanityUpdatedAt: string | undefined;
}

export interface FormModel extends BaseDocumentModel {
  identifier: string | undefined;
  title: string | undefined;
  receipt: FormReceiptModel | undefined;
  pages: IFormPage[] | undefined;
  globalLabels: FormGlobalLabelsModel | undefined;
}

export interface FormReceiptModel {
  title: string | undefined;
  text: string | undefined;
  backLabel: string | undefined;
}

export interface IFormPage {
  fields: IFormField[] | undefined;
  validationCandidates: IValidationCandidate[] | undefined;
}

export interface IFormField {
  key: string | undefined;
  fieldType: string | undefined;
  name: string | undefined;
  value: any | undefined;
  initialValue: string | undefined;
  label: string | undefined;
  validationRules: IValidationRule[] | undefined;
}

export interface IValidationRule {
  ruleType: string | undefined;
  errorMessage: string | undefined;
}

export interface IValidationCandidate {
  value: any | undefined;
  validationRules: IValidationRule[] | undefined;
  name: string | undefined;
}

export interface FormGlobalLabelsModel {
  nextLabel: string | undefined;
  previousLabel: string | undefined;
  summaryLabel: string | undefined;
  submitLabel: string | undefined;
  saveLabel: string | undefined;
  savingLabel: string | undefined;
  savedLabel: string | undefined;
  saveFailedLabel: string | undefined;
  listTitleLabel: string | undefined;
  introductionLabel: string | undefined;
  newFormLabel: string | undefined;
  applicationHeaderLabel: string | undefined;
  stateHeaderLabel: string | undefined;
  deleteHeaderLabel: string | undefined;
  untitledLabel: string | undefined;
  submittedLabel: string | undefined;
  submitFailedLabel: string | undefined;
  draftLabel: string | undefined;
  deletePromptLabel: string | undefined;
  deleteYesLabel: string | undefined;
  deleteNoLabel: string | undefined;
}

export enum FormApplicationTypeEnum {
  PayoutRequestGrant = 'PayoutRequestGrant',
  GreenPlatform = 'GreenPlatform',
  FastForward = 'FastForward',
}

export interface FormActionDto {
  applicationType: FormApplicationTypeEnum;
  actionType: FormActionTypeEnum;
  data: any | undefined;
}

export enum FormActionTypeEnum {
  OpenForm = 'OpenForm',
  OpusRedirect = 'OpusRedirect',
}

export enum BankAccountCategoryEnum {
  Unknown = 'Unknown',
  Loan = 'Loan',
  Grant = 'Grant',
  Guarantee = 'Guarantee',
  InterestSubsidy = 'InterestSubsidy',
  BackingGuarantee = 'BackingGuarantee',
}

export interface CustomerDocumentDto {
  id: string | undefined;
  documentType: DocumentType;
  name: string | undefined;
  description: string | undefined;
  length: number;
  created: string;
  modified: string;
}

export enum DocumentType {
  Unknown = 'Unknown',
  BankingAnnualStatement = 'BankingAnnualStatement',
}

export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;
  extensions: { [key: string]: any } | undefined;
}

export interface BankAccountOverviewSummaryDto {
  loans: BankAccountOverviewDto[] | undefined;
  guarantees: BankAccountOverviewDto[] | undefined;
  grants: BankAccountOverviewDto[] | undefined;
  interestSubsidies: BankAccountOverviewDto[] | undefined;
}

export interface BankAccountOverviewDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  category: BankAccountCategoryEnum;
  projectNo: string | undefined;
  amount: number;
  availableAmount: number;
  approveDate: string | undefined;
  paymentAccountNumber: string | undefined;
}

export enum BankAccountStatusEnum {
  Other = 'Other',
  Active = 'Active',
  Approved = 'Approved',
  Inactive = 'Inactive',
  Expired = 'Expired',
  InvoiceOverDue = 'InvoiceOverDue',
  DebtCollectionKredinor = 'DebtCollectionKredinor',
  DebtCollectionConecto = 'DebtCollectionConecto',
  Bankrupt = 'Bankrupt',
  PartiallyPaid = 'PartiallyPaid',
}

export interface GrantDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  projectNo: string | undefined;
  availableAmount: number | undefined;
  originalAmount: number | undefined;
  blockedAmount: number | undefined;
  bookBalance: number | undefined;
  approveDate: string;
  expiryDate: string;
  payoutDeadline: string | undefined;
}

export interface InterestSubsidyDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  typeCode: string | undefined;
  typeName: string | undefined;
  projectNo: string | undefined;
  totalAmount: number | undefined;
  availableAmount: number | undefined;
  payoutAmount: number | undefined;
  approveDate: string | undefined;
  matureDate: string | undefined;
  interestRate: number | undefined;
  nextPayoutDate: string | undefined;
  nextPayoutAmount: number | undefined;
}

export interface LoanOverviewViewModel {
  loanOverview: BankAccountOverviewDto | undefined;
  openInvoices: InvoiceDto[] | undefined;
}

export interface InvoiceDto {
  amortizationAmount: number | undefined;
  customerIdentification: string | undefined;
  dueDate: string | undefined;
  originalDueDate: string | undefined;
  expensesAmount: number | undefined;
  feeDelayAmount: number | undefined;
  feeInvoiceAmount: number | undefined;
  interestAmount: number | undefined;
  invoiceNumber: number;
  lastPayDate: string | undefined;
  paidAmount: number | undefined;
  printPenaltyAmount: number | undefined;
  status: InvoiceStatusEnum;
  totalAmount: number | undefined;
  type: InvoiceTypeEnum;
  version: number | undefined;
}

export enum InvoiceStatusEnum {
  Undefined = 'Undefined',
  Due = 'Due',
  Pending = 'Pending',
  Overdue = 'Overdue',
  Replaced = 'Replaced',
  Reminder = 'Reminder',
  Default = 'Default',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  ZeroReminder = 'ZeroReminder',
  Preliminary = 'Preliminary',
  Composite = 'Composite',
  Terminate = 'Terminate',
  Postponed = 'Postponed',
  Loss = 'Loss',
  Transported = 'Transported',
  External = 'External',
  Cleared = 'Cleared',
}

export enum InvoiceTypeEnum {
  CommonMaster = 'CommonMaster',
  Ordinary = 'Ordinary',
  Reminder = 'Reminder',
  Termination = 'Termination',
  LeaseResidual = 'LeaseResidual',
  LeaseTermination = 'LeaseTermination',
  Credit = 'Credit',
  Repurchasor = 'Repurchasor',
  Undefined = 'Undefined',
  IndependentReminder = 'IndependentReminder',
  Zero = 'Zero',
  Detached = 'Detached',
  HirePurchaseActivation = 'HirePurchaseActivation',
  Factoring = 'Factoring',
  FactoringReminder = 'FactoringReminder',
  LeaseResidualReminder = 'LeaseResidualReminder',
  Correction = 'Correction',
  TerminationNote = 'TerminationNote',
  FactoringCredit = 'FactoringCredit',
  RemindLoanLoss = 'RemindLoanLoss',
  FactoringCommonReminder = 'FactoringCommonReminder',
  FactoringFee = 'FactoringFee',
  VatUpfront = 'VatUpfront',
}

export interface LoanDetailsViewModel {
  loanDetails: LoanDetailsDto | undefined;
  collaterals: CollateralDto[] | undefined;
}

export interface LoanDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  typeCode: string | undefined;
  typeName: string | undefined;
  projectNo: string | undefined;
  totalAmount: number | undefined;
  availableAmount: number | undefined;
  payoutAmount: number | undefined;
  blockedAmount: number | undefined;
  bookBalance: number | undefined;
  approveDate: string | undefined;
  matureDate: string | undefined;
  interestRate: number | undefined;
  effectiveRate: number | undefined;
  payMethod: PaymentMethodEnum | undefined;
  periodMonths: number | undefined;
  periodFee: number | undefined;
  openFee: number | undefined;
  openFeePercent: number | undefined;
  interestType: InterestTypeEnum;
  fixedInterestExpiryDate: string | undefined;
  paymentAccountNumber: string | undefined;
}

export enum PaymentMethodEnum {
  Serial = 'Serial',
  Annuity = 'Annuity',
}

export enum InterestTypeEnum {
  NotSpecified = 'NotSpecified',
  Floating = 'Floating',
  Fixed = 'Fixed',
  Free = 'Free',
}

export interface CollateralDto {
  name: string | undefined;
  customerId: string | undefined;
  customerType: CustomerTypeEnum;
  type: CollateralTypeEnum;
}

export enum CustomerTypeEnum {
  Company = 'Company',
  Person = 'Person',
  Foreign = 'Foreign',
  Constellation = 'Constellation',
  InternalCostCenters = 'InternalCostCenters',
}

export enum CollateralTypeEnum {
  Debtor = 'Debtor',
  CoDebtor = 'CoDebtor',
  Guarantor = 'Guarantor',
  RealSurety = 'RealSurety',
}

export interface GuaranteeDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  projectNo: string | undefined;
  bookBalance: number | undefined;
  grossPrincipal: number | undefined;
  startDate: string | undefined;
  expiryDate: string | undefined;
  periodMonths: number | undefined;
  interestRate: number | undefined;
  openFee: number | undefined;
}

export interface PaymentPlanOverviewDto {
  current: string | undefined;
  currentPlan: PaymentPlanEntryDto[] | undefined;
  yearRange: string | undefined;
  yearPlan: PaymentPlanEntryDto[] | undefined;
}

export interface PaymentPlanEntryDto {
  dueDate: string;
  interest: number;
  amortization: number;
  termFee: number;
  totalAmount: number;
  endBalance: number;
}

export interface TransactionOverviewDto {
  transactionDate: string | undefined;
  transactionCategory: TransactionCategoryEnum;
  amount: number | undefined;
  invoiceNumber: number | undefined;
}

export enum TransactionCategoryEnum {
  Other = 'Other',
  Transfer = 'Transfer',
  Payment = 'Payment',
  Blocking = 'Blocking',
  OpenFee = 'OpenFee',
  Refund = 'Refund',
  CommisionPayment = 'CommisionPayment',
  CommisionRefund = 'CommisionRefund',
}

export interface FileParameter {
  data: any;
  fileName: string;
}
